export const normalizeCode = (value?: unknown) => `${value ?? ""}`.trim().toUpperCase()

export const normalizeId = (value?: unknown) => `${value ?? ""}`.trim()
